const columns = [
  {
    title: "连板数",
    dataIndex: "days",
    scopedSlots: { customRender: "days" },
    sorter: (a, b) => a.days - b.days,
    sortDirections: ["descend", "ascend"]
  },
  {
    title: "板块",
    dataIndex: "plates",
    scopedSlots: { customRender: "plates" }
  },
  {
    title: "股票名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "代码",
    dataIndex: "symbol",
    scopedSlots: { customRender: "symbol" }
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export { columns };
